module.exports = __webpack_public_path__ + "media/honey-icons/icon-shop-8563d2c6.svg";